<template>
  <div>
    <div class="w-full flex justify-end mb-2">
      <DxButton
        v-if="options.allowToRefetch"
        style="margin-left: 5px;"
        icon="refresh"
        type="normal"
        @click="
          () => {
            $parent.fetchData()
          }
        "
      />
      <DxButton
        v-if="options.allowExporting"
        style="margin-left: 5px;"
        icon="export"
        type="normal"
        @click="exportToExcelNow()"
      />
    </div>
    <DxDataGrid
      id="formulaListTable"
      ref="formulaListTable"
      :data-source="items"
      :show-borders="true"
      :row-alternation-enabled="true"
      :allow-column-resizing="true"
      :column-min-width="100"
      key-expr="Id"
    >
      <!-- Paging and Pager -->
      <DxPaging :page-size="10" />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[10, 20, 50]"
        :show-info="true"
      />

      <DxColumnFixing :enabled="true" />

      <!-- Set Columns -->
      <DxColumn
        v-for="(head, index) in headers"
        :key="index"
        :width="null"
        :data-type="head.type"
        :caption="head.text"
        :data-field="head.value"
        :cell-template="head.cellTemplate"
        :allow-sorting="head.text !== 'Action' && options.allowSorting"
        :allow-filtering="head.text !== 'Action'"
        :visible="head.visible"
      />

      <!-- Activate Filter -->
      <DxFilterRow :visible="true" />

      <!-- Activate Export -->
      <DxExport :enabled="false" :allow-export-selected-data="true" />

      <DxMasterDetail :enabled="true" template="masterDetailTemplate" />

      <template #masterDetailTemplate="{ data: formula }">
        <div>
          <FormulaDetail
            v-if="formula.data.ProcessForm === 'formula'"
            :formula="formula.data"
          />
          <SensorDetail
            v-if="formula.data.ProcessForm !== 'formula'"
            :formula="formula.data"
          />
        </div>
      </template>

      <template #tagColumn="{ data }">
        <div>
          <el-tag
            :type="tagColors[getRandomInt(1, tagColors.length)]"
            class="ml-2 mt-2"
            v-for="(tag, index) in data.data.Tags"
            :key="index"
            effect="plain"
          >
            {{ tag }}
          </el-tag>
        </div>
      </template>

      <template #commonAction="{ data }">
        <center>
          <el-button
            title="Edit"
            icon="el-icon-edit-outline"
            type="primary"
            size="mini"
            @click="editData(data.row)"
            circle
          >
          </el-button>
          <el-button
            title="Remove"
            icon="el-icon-delete"
            type="danger"
            size="mini"
            @click="remove(data.row)"
            circle
          >
          </el-button>
        </center>
      </template>
    </DxDataGrid>

    <!-- Dialog delete -->
    <el-dialog :visible.sync="dialogVisible" width="30%"></el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import {
  DxForm,
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxEditing,
  DxSelection,
  DxFilterRow,
  DxExport,
  DxColumnFixing,
  DxMasterDetail
} from 'devextreme-vue/data-grid'
import {
  DxSimpleItem,
  DxLabel,
  DxRequiredRule,
  DxPatternRule
} from 'devextreme-vue/form'
import DxButton from 'devextreme-vue/button'
import { DxTextBox } from 'devextreme-vue/text-box'
import FormulaDetail from '@/components/formula/FormulaDetail'
import SensorDetail from '@/components/formula/SensorDetail'
// import AppIcon from '@/components/AppIcon'
import notify from 'devextreme/ui/notify'
import { exportDataGrid } from 'devextreme/excel_exporter'
import ExcelJS from 'exceljs'
import saveAs from 'file-saver'

export default {
  props: {
    headers: {
      type: Array
    },
    items: {
      type: Array
    },
    options: {
      type: Object
    },
    customizationPage: {
      type: String
    }
  },
  components: {
    // AppIcon,

    AppIcon: () => import('@/components/AppIcon'),
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxEditing,
    DxForm,
    DxSelection,
    DxFilterRow,
    DxExport,
    DxSimpleItem,
    DxLabel,
    DxRequiredRule,
    DxPatternRule,
    DxTextBox,
    DxColumnFixing,
    DxMasterDetail,
    DxButton,
    FormulaDetail,
    SensorDetail
  },
  data: () => {
    return {
      alphaPattern: /^[^0-9]+$/, // eslint-disable-line
      numericPattern: /^(0|[1-9][0-9]*)$/, // eslint-disable-line
      emailPattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, // eslint-disable-line
      dialogVisible: false,
      tagColors: ['', 'success', 'info', 'danger', 'warning']
    }
  },
  methods: {
    log(eLog) {
      console.log('logging', eLog)
    },
    validateForm(e) {
      e.component.validate()
    },
    customEdit(page, id, mode = 'edit') {
      this.$router.push({ path: page, query: { mode: mode, id: id } })
    },
    onSelectionChanged({ selectedRowsData }) {
      this.$emit('selection-changed', selectedRowsData)
    },
    getRandomInt(min = 1, max = 10, withDecimal = false) {
      return withDecimal
        ? (Math.random() * (max - min) + min).toFixed(2)
        : Math.floor(Math.random() * (max - min) + min)
    },
    exportToExcelNow() {
      const context = this
      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet(this.pageTitle)

      exportDataGrid({
        component: context.datagridInstance,
        worksheet: worksheet,
        autoFilterEnabled: true
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: 'application/octet-stream' }),
            `Formula List - ${Date.now()}.xlsx`
          )
        })
      })

      this.$emit('exportToExcelFinish', true)
    },
    editData(value) {
      var data = value.data
      this.$router.push({
        name: 'formula-config',
        query: {
          Id: data.Id,
          customerId: data.DetailCompany.DcoId
        }
      })
    },
    async remove(row) {
      var _this = this
      this.$confirm(
        'This will permanently delete this Custom Formula. Continue?',
        'Are you sure',
        {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(async () => {
          try {
            var id = row.data.Id

            const res = await this.$axios.delete(
              this.$appInfo.api.formula.delete + `?id=${id}`
            )

            this.$parent.fetchData()

            _this.$message({
              type: 'success',
              message: 'Custom Formula Removed'
            })
          } catch (e) {
            _this.$message.error(e)
            console.log(e)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          })
        })
    }
  },
  computed: {
    datagridInstance: function () {
      return this.$refs.formulaListTable.instance
    },
    imageExtension() {
      const data = ['png', 'jpg', 'jpeg', 'ico', 'webp', 'svg']
      return data
    },
    fileExtension() {
      const type = ['pdf', 'xls', 'pptx', 'doc', 'docx', 'txt']
      return type
    }
  }
}
</script>

<style>
.dx-template-wrapper {
  white-space: normal !important;
}
</style>
